import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";

import TableMyExperiments from "./CreateDistillationTabs/TableMyExperiments";
import TableAllExperiments from "./CreateDistillationTabs/TableAllExperiments";
import FilterMenu from "../../components/FilterMenu"
import { useUser } from "../../context/UserContext";

import DistillationExperiment from '../../api/Distillation/DistillationExperiment'
import DistillationStatus from '../../api/Distillation/DistillationStatus'

import { FilterButton, GlobalButton, GlobalSecondaryButton, GlobalTabCollection, StyledTab } from "../../pages/styles";

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { applyFiltersToArray, exportToCsv } from "../../global";

const CreateDistillation = () => {
  const [tabValue, setTabValue] = useState(0);
  const [statuses, setStatuses] = useState([])
  const [allExperiments, setAllExperiments] = useState([])
  const [isAllExperimentsLoading, setIsAllExperimentsLoading] = useState(true)
  const [isMyExperimentsLoading, setIsMyExperimentsLoading] = useState(true)
  const [filteringOpen, setFilteringOpen] = useState(false);
  const [filters, setFilters] = useState([{name:null, displayName:null, operator:null, enumValues:[], value:''}])

  const { username } = useUser();

  const filterOptions = [
    {name: "id", displayName: "Experiment ID", type: "integer", enumValues: []}, 
    {name: "mnemonic", displayName: "Mnemonic", type: "string", enumValues: []}, 
    {name: "experimentDescription", displayName: "Experiment Description", type: "string", enumValues: []},
    {name: "requestedByEmail", displayName: "Requester Email", type: "string", enumValues: []},
    {name: "createdDate", displayName: "Requested Date", type: "date", enumValues: []},
    {name: "distillationStatusName", displayName: "Status", type: "enum", enumValues: statuses}
  ]

  const getAllExperiments = async () => {
    setIsAllExperimentsLoading(true)
    setIsMyExperimentsLoading(true)
    setAllExperiments([])
    const data = await DistillationExperiment.getAllExperiments()
    setAllExperiments(data)
    setIsAllExperimentsLoading(false)
    setIsMyExperimentsLoading(false)
  }
  
  const updateExperiment = async (payload) => {
    const result = await DistillationExperiment.updateExperiment(payload)
    getAllExperiments()
    return result;
  }
  
  const getAllDistillationStatuses = async () => {
    const data = await DistillationStatus.getAllDistillationStatuses()
    const formattedData = data.map((status) => status?.distillationStatusName)
    const filteredData = formattedData.filter(status => status?.isActive)
    const activeStatuses = filteredData.map(status => status?.distillationStatusName)
    setStatuses(activeStatuses)
  }

  const handleChange = (event, newValue) => {
    clearFiltersClick()
    setTabValue(newValue);
  };

  const clearFiltersClick = (event) => {
    setFilters([{name:null, displayName:null, operator:null, enumValues:[], value:null}])  
  }

  const renderSearchTab = () => {
    switch (tabValue) {
      case 0: {
        return (
          <TableMyExperiments 
            filters={filters}
            myExperiments={allExperiments.filter((experiment) => {
              return experiment?.requestedByEmail === username
            })} 
            isDataLoading={isMyExperimentsLoading} 
            userEmail={username}
            updateExperiment={updateExperiment}
          />
        )
      }
      case 1: {
        return (
          <TableAllExperiments 
            filters={filters}
            allExperiments={allExperiments} 
            isDataLoading={isAllExperimentsLoading}
          />
        )
      }
      default: {
        alert(tabValue);
      }
    }
  };

  const renderExportCSV = () => {
      switch (tabValue) {
        case 0: {
          return <>
            <FileDownloadIcon sx={{ m: 1 }} style={{ cursor: "pointer" }} onClick={e => exportToCsv(applyFiltersToArray(filters, allExperiments.filter((experiment) => {
                return experiment?.requestedByEmail === username
              })).map(container => {
              return {
                "Experiment ID": container.id,
                Mnemonic: container.mnemonic,
                "Experiment Description": container.experimentDescription,
                "Requester Email": container.requestedByEmail,
                "Requested Date": container.createdDate,
                Status: container.distillationStatusName
              }
            }), "My Experiments")} />
          </>
        }
        case 1: {
          return <>
            <FileDownloadIcon sx={{ m: 1 }} style={{ cursor: "pointer" }} onClick={e => exportToCsv(applyFiltersToArray(filters, allExperiments).map(container => {
              return {
                "Experiment ID": container.id,
                Mnemonic: container.mnemonic,
                "Experiment Description": container.experimentDescription,
                "Requester Email": container.requestedByEmail,
                "Requested Date": container.createdDate,
                Status: container.distillationStatusName
              }
            }), "All Experiments")} />
          </>
        }
        default:
        break;
    }}

  useEffect(() => {
    getAllExperiments()
    getAllDistillationStatuses()
  }, [])

  return (
       <div>
         <Box sx={{ bgcolor: "#fff", pt:3, pb:1 }}>
          <GlobalTabCollection value={tabValue} onChange={handleChange} aria-label='ant example'>
            <StyledTab label='My Experiments' />
            <StyledTab label='All Experiments' />
            <Box>
              <GlobalButton
                variant="contained" 
                component={Link}
                to='/newExperiment'
              >
                Create New Experiment
              </GlobalButton>
            </Box>
            <Box display="flex" alignItems="center" marginLeft="auto">
              <FilterButton      
                variant="contained"
                onClick={() => setFilteringOpen(true)}
                filtered={!(filters[0].name === null)}
              >
                Filters
              </FilterButton>
              {!(filters[0].name === null) && (
                <GlobalSecondaryButton  
                  style={{marginLeft:"1rem"}}
                  variant="contained" 
                  onClick={() => clearFiltersClick()}
                >
                  Clear Filters
                </GlobalSecondaryButton>
              )} 
              {renderExportCSV()}
            </Box>
          </GlobalTabCollection>
        </Box>
        {renderSearchTab()}
        <FilterMenu 
          moduleName="create-distillation"
          open={filteringOpen} 
          setOpen={setFilteringOpen} 
          applyBtnAction={() => setFilteringOpen(false)} 
          cancelButtonAction={() => setFilteringOpen(false)} 
          filteringInfo={filterOptions} 
          appliedFilters={filters} 
          setAppliedFilters={setFilters}
        />
      </div>
  );
};

export default CreateDistillation;
